$bog_pazzle_settings $mol_list
	grid_rows? 4
	grid_columns? 4
	numbers? true
	Preset* $mol_button_minor
		title <= preset_title* \
		click? <=> preset_pick*? null
		attr *
			^
			bog_pazzle_current <= preset_current* false
	rows /
		<= Size $mol_labeler
			title \Размер сетки
			content /
				<= Size_row $mol_view
					sub /
						<= Rows_input $mol_number
							value_min 2
							value_max 12
							value? <=> grid_rows?
							hint \строк
						<= Times $mol_text
							text \×
						<= Columns_input $mol_number
							value_min 2
							value_max 12
							value? <=> grid_columns?
							hint \столбцов
		<= Presets $mol_view
			sub <= presets /
		<= Numbers $mol_check_box
			title \Показывать номера фрагментов
			checked? <=> numbers?
